// extracted by mini-css-extract-plugin
export default {"productDescription":"U--z","featuredDescription":"V--z","description":"W--z","more":"X--z","descriptionSku":"Y--z"};